import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Observer, Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class PublisherService {
  constructor(private dataService: DataService) {
  }
  url = environment.api_base_url;


  getPublishersList(pageNo: number, pageSize: number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "management/publishers?pageNo=" + pageNo + "&pageSize=" + pageSize).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getAllPublishers(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "management/publishers/all").subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getPublisherById(id: number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "management/publishers/" + id).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  savePublisher(data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.post(this.url + "management/publishers", data).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  updatePublisher(id: number, data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.put(this.url + "management/publishers/" + id, data).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getDownloadURL(): any {
    const authToken = sessionStorage.getItem("authToken");
    return this.url + "management/publishers/download?token=" + authToken;
  }

  downloadPublisher(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.download(this.url + "management/publishers/download").subscribe((result: any) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

}